export default "__VITE_ASSET__BDm$MN2O__"